import clsx from 'clsx';
import { Children, CSSProperties, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  activeIndex: number;
  spanClassName?: string;
} & HTMLAttributes<HTMLDivElement>;

const TabsList = ({ activeIndex, children, className, spanClassName, style, ...props }: Props) => {
  const numChildren = Children.count(children);
  const lastTabActive = activeIndex === numChildren - 1;

  return (
    <div
      className={twMerge(
        clsx(
          'relative mx-auto mb-32 rounded-full border-[1.3px] border-grey-75 bg-grey-50 p-3',
          'grid [grid-template-columns:repeat(var(--num-cols),minmax(0,1fr))]',
          className,
        ),
      )}
      style={{ '--num-cols': numChildren, ...style } as CSSProperties}
      {...props}
    >
      {children}
      <span
        className={twMerge(
          clsx(
            'tab-toggle absolute bottom-4 top-4 h-[calc(100%-8px)] rounded-full bg-primary-400 transition-transform duration-500 w-[var(--tab-width)]',
            'translate-x-[var(--toggle-translate)]',
            spanClassName,
          ),
        )}
        style={
          {
            '--tab-width': `calc(${100 / numChildren}% - ${3 * Math.ceil(numChildren / 2)}px)`,
            '--toggle-translate':
              activeIndex === 0
                ? '4px'
                : `calc(${100 * activeIndex}% + ${8 * activeIndex - (lastTabActive ? 4 : 0)}px)`,
          } as CSSProperties
        }
      />
    </div>
  );
};

export default TabsList;
